
import React, { useState, useEffect } from "react";
import L from 'leaflet'
import styled from "styled-components";
import Api from "../../../../api";
import message from "../../../../components/Messages";
import Constant from "../../../../constants/constant"
import Api_tnn from "../../../../api/api.tnn";
import Api_spatial from "../../../../api/api.spatial";
import Api_dms from "../../../../api/api.dms";
import { Col, Tabs, Row, Radio, Modal } from "antd";
import { FastField } from "formik";
import FilterWrapper from "../../../../components/Common/FilterWrapper";
import columns from "../Colums/CTThuocSongList.column";
import columnsDuAn from "../Colums/DuAnList.column";
import columsHangMuc from "../Colums/HangMucList.column";
import columnsGP from "../Colums/GiayPhepList.column";
import columnsDTM from "../Colums/DTM.column";
import columnsBVMT from '../Colums/BVMT.column'
import Select from "../../../../components/Common/Select";
import typo, { MESSAGE } from "../../../../constants/dictionaries";
import helper from "../../../../helper/helper";
import SearchInput from "../../../../components/Common/Input/SearchInput";
import Table from "../../../../components/Table";
import Api_quantrac from "../../../../api/api.quantrac";
import DownloadFileModal from '../../../../components/DownloadFile'
import DTMDetail from '../../../DTM/BaoCaoPheDuyet/detail/detailForm'
import BVMTDetail from '../../../BaoVeMoiTruong/DeAnChiTiet/detail/detailForm'
import GiayPhepDetail from "../GiayPhep"
import InfoTramQTModal from "../Modal/routerTramInfo"
import InfoTramQT_HTMT from "../../../HienTrangMoiTruong/TramQuanTrac/detail"
const { TabPane } = Tabs;
const ControllerCheckbox = styled.div`
  margin-bottom: 15px;
`;
const FuncMap = ({ dulieu_congtrinh, user, tenTinh, tenHuyen, dulieu_moitruong }) => {
    const [roledvhc, setroledvhc] = useState(null);
    const [filterInfo, setfilterInfo] = useState({
        strSearch: "",
        idTinh: undefined,
        idHuyen: undefined,
        idXa: undefined,
        idTimKiem: "",
    });
    const [data_modal_mau, setdata_modal_mau] = useState({
        idGiayPhep: undefined,
        idTramQT: undefined,
        loai: undefined,
        kyHieu: undefined
    });
    const [data_tinh, setdata_tinh] = useState([]);
    const [data_huyen, setdata_huyen] = useState([]);
    const [dataCTbyGiayPhep, setdataCTbyGiayPhep] = useState([]);
    const [dataThuocHuyen, setdataThuocHuyen] = useState([]);
    const [pagination, setpagination] = useState({});
    const [loaiTimKiem, setloaiTimKiem] = useState(1);
    const [displayInfo, setdisplayInfo] = useState("none");
    const [dataDTM, setdataDTM] = useState([]);
    const [dataBVMT, setdataBVMT] = useState([]);
    const [selectedItemGP, setselectedItemGP] = useState(null);
    const [setModal, setsetModal] = useState(null);
    const [selectdFile, setselectdFile] = useState([]);
    const [selected_DTM, setselected_DTM] = useState(null);
    const [selected_BVMT, setselected_BVMT] = useState(null);
    const [selectedItemInfo_tramQT, setselectedItemInfo_tramQT] = useState(null);
    const [selectedItemInfo_tramQT_HTMT, setselectedItemInfo_tramQT_HTMT] = useState(null);


    useEffect(() => {
        Profile()
        if (Constant.CAP_TRIEN_KHAI === 1) {
            getApiTinhs()
        } else if (Constant.CAP_TRIEN_KHAI === 2) {
            getApiHuyenByTinhs(Constant.MA_TINH)
            setfilterInfo({
                strSearch: "",
                idTinh: String(Constant.MA_TINH),
                idHuyen: undefined,
                idXa: undefined,
                idTimKiem: "",
            })
        }
    }, []);

    function Profile() {
        new Api().Profile({ token: user.access_token })
            .then((res) => {
                setroledvhc(res.roles[0].cap === 3 ? res.maDVHC : "1000")
            })
            .catch((err) => message.error(err.message));
    }
    function getApiTinhs() {
        new Api()
            .getTinhs({ token: user.access_token })
            .then((res) => {
                setdata_tinh(res)
            })
            .catch((err) => {
                message.error(err.message);
            });
    }
    function getApiHuyenByTinhs(maTinh) {
        new Api()
            .getHuyenByTinhs({
                token: user.access_token,
                maTinh: maTinh,
            })
            .then((res) => {
                setdata_huyen(res)
            })
            .catch((err) => {
                message.error(err.message);
            });
    }
    function GetCT_GiayPheps(strSearch, page, size) {
        new Api_tnn()
            .GetCT_GiayPheps({
                token: user.access_token,
                strSearch: strSearch,
                roledvhc: roledvhc,
                page: page,
                size: size,
            })
            .then((res) => {
                setdataCTbyGiayPhep(res && res.data.map((item, index) => ({
                    ...item,
                    stt: index + 1,
                    svb_ngayky: item.soVanBan + " - " + helper.formatDate(item.ngayKy),
                })))
                setpagination(res && res.pagination)
            })
            .catch((err) => {
                message.error(err.message);
            });
    }
    function getDataDTM(strSearch, page, size) {
        new Api_quantrac()
            .GetDTMs({
                token: user.access_token,
                strSearch: strSearch,
                page: page,
                size: size,
                roledvhc: roledvhc
            })
            .then(res => {
                setdataDTM(res && res.data.map((item, index) => ({
                    ...item,
                    stt: index + 1,
                    svb_ngayky: item.soQD + " - " + helper.formatDate(item.ngayKy)
                })))
                setpagination(res && res.pagination)
            })
            .catch(err => message.error(err.message))
    };
    function getDataBVMT(strSearch, page, size) {
        new Api_quantrac()
            .GetBVMTs({
                token: user.access_token,
                strSearch: strSearch,
                page: page,
                size: size,
                roledvhc: roledvhc
            })
            .then(res => {
                setdataBVMT(res && res.data.map((item, index) => ({
                    ...item,
                    stt: index + 1,
                    svb_ngayky: item.soQD + " - " + helper.formatDate(item.ngayKy)
                })))
                setpagination(res && res.pagination)
            })
            .catch(err => message.error(err.message))
    };
    function GetSpatialThuocDVHC(tenhuyen, tentinh) {
        new Api_spatial()
            .GetSpatialThuocDVHC({
                token: user.access_token,
                tenhuyen: tenhuyen,
                tentinh: tentinh,
            })
            .then((res) => {
                setdataThuocHuyen(res)
            })
            .catch((err) => {
                message.error(err.message);
            });
    }
    function downFile(data) {
        new Api_dms().DownloadFile({
            token: user.access_token,
            data: { oid: data.idFile, filename: data.tenTaiLieu },
        });
    }
    function showFileMT(item) {
        if (item.files !== undefined || item.files !== []) {
            if (item.files.length > 1) {
                setsetModal(true)
                setselectdFile(item.files)
            } else {
                downFile(item.files[0])
            }
        }
    }
    function handleShowDTMDetail(row) {
        setselected_DTM(row.id)
    }
    function handleShowBVMTDetail(row) {
        setselected_BVMT(row.id)
    }
    function handleShowGPDetail(record) {
        dulieu_congtrinh(record.idCongTrinh, record.loaiCongTrinh)
        setselectedItemGP(record.id)
    }
    function onChangeTimKiem(e) {
        setloaiTimKiem(e.target.value)
    }
    function searchGiayPhep(strSearch) {
        setdataThuocHuyen([])
        setdisplayInfo(["block"])
        GetCT_GiayPheps(strSearch, 1, 10)
        getDataDTM(strSearch, 1, 10)
        getDataBVMT(strSearch, 1, 10)
    }
    function handleTableParamsChange(pagination, filteredInfo, sortedInfo, value, loai) {
        if (loai === "GP") {
            GetCT_GiayPheps(value.strSearch, pagination.current, 10)
        } else if (loai === "DTM") {
            getDataDTM(value.strSearch, pagination.current, 10)
        } else if (loai === "BVMT") {
            getDataBVMT(value.strSearch, pagination.current, 10)
        }
    }
    function SelectTinh(value, name) {
        setdisplayInfo(["block"])
        setdataCTbyGiayPhep([])
        GetSpatialThuocDVHC("", name.props.children)
    }
    function SelectHuyen(value, name) {
        GetSpatialThuocDVHC(name.props.children, "")
        setdisplayInfo(["block"])
        setdataCTbyGiayPhep([])
    }
    function handleCancel() {
        setsetModal(null)
        setselected_DTM(null)
        setselected_BVMT(null)
        setselectedItemGP(null)
        setselectedItemInfo_tramQT(null)
        setselectedItemInfo_tramQT_HTMT(null)
        setselectdFile([])
        setdata_modal_mau({
            idGiayPhep: undefined,
            idTramQT: undefined,
            loai: undefined,
            kyHieu: undefined
        })
    }
    return (
        <ControllerCheckbox>
            <Row type="flex" justify="start" style={{ paddingTop: "10px" }}>
                <Col>
                    <FilterWrapper
                        initialValues={filterInfo}
                        hideButton={true}
                        handleApplyFilter={() => { }}
                    >
                        {({ handleChange, setFieldValue, values, handleSubmit, }) => (
                            <Col>
                                <Row style={{ marginLeft: "25px" }}>
                                    <Radio.Group onChange={(e) => onChangeTimKiem(e)} value={loaiTimKiem}>
                                        <Radio value={1}><b style={{ fontWeight: 600 }}>Tìm theo từ khóa</b></Radio>
                                        <Radio value={2}><b style={{ fontWeight: 600 }}>Tìm theo đơn vị hành chính</b></Radio>
                                    </Radio.Group>
                                </Row>
                                <div className="mt-10" />
                                <Row type="flex" style={{ marginLeft: "25px" }}>
                                    {Number(loaiTimKiem) === 1 && (
                                        <Col>
                                            <FastField name="strSearch" render={({ field }) => (
                                                <SearchInput width="450px" {...field}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            setFieldValue("idTinh", undefined);
                                                            setFieldValue("idHuyen", undefined);
                                                            setFieldValue("idXa", undefined);
                                                            setFieldValue("strSearch", e.target.value);
                                                            searchGiayPhep(e.target.value);
                                                        }
                                                    }}
                                                />
                                            )}
                                            />
                                            <div style={{ color: "#aba2a2", marginTop: "10px" }}>Nhập từ khóa về giấy phép, địa điểm, tổ chức cá nhân,... Ví dụ: Hà Nội, 234/GP-BTNMT</div>
                                        </Col>
                                    )}
                                </Row>
                                <div className="mt-10" />
                                <Row style={{ marginLeft: "25px" }}>
                                    {Constant.CAP_TRIEN_KHAI === 1 &&
                                        Number(loaiTimKiem) === 2 && (
                                            <Col>
                                                <Select
                                                    mandatory={false}
                                                    placeholder={helper.genSelectPL(typo.cscore_province_placeholder)}
                                                    onChange={(value, name) => {
                                                        setFieldValue("idTinh", value);
                                                        setFieldValue("tentinh", name.props.children);
                                                        setFieldValue("strSearch", undefined);
                                                        SelectTinh(value, name);
                                                        tenTinh(name.props.children)
                                                        tenHuyen(undefined)
                                                    }}
                                                    dataSource={data_tinh}
                                                    width="450px"
                                                    name="tenDVHC"
                                                    name_value="maTinh"
                                                    defaultValue={values.idTinh}
                                                    key={values.idTinh}
                                                    alowClear={true}
                                                />
                                            </Col>
                                        )}
                                </Row>
                                <div className="mt-10" />
                                <Row style={{ marginLeft: "25px" }}>
                                    {Constant.CAP_TRIEN_KHAI === 2 &&
                                        Number(loaiTimKiem) === 2 && (
                                            <Col>
                                                <Select
                                                    mandatory={false}
                                                    placeholder={helper.genSelectPL(typo.cscore_district_placeholder)}
                                                    onChange={(value, name) => {
                                                        setFieldValue("idHuyen", value);
                                                        setFieldValue("tenhuyen", name.props.children);
                                                        setFieldValue("idXa", undefined);
                                                        setFieldValue("strSearch", undefined);
                                                        SelectHuyen(value, name);
                                                        tenTinh(undefined)
                                                        tenHuyen(name.props.children)
                                                    }}
                                                    dataSource={data_huyen}
                                                    width="450px"
                                                    name="tenDVHC"
                                                    name_value="maHuyen"
                                                    defaultValue={values.idHuyen}
                                                    key={values.idHuyen}
                                                />
                                            </Col>
                                        )}
                                </Row>
                                <div className="mt-10" />
                                <Row>
                                    <Col style={{ width: "450px", marginLeft: "25px", display: displayInfo }}>
                                        {dataCTbyGiayPhep && !dataThuocHuyen.qt_bvmt_tramquantrac_intersect && (
                                            <Tabs type="card">
                                                <TabPane tab="Giấy phép" key="1">
                                                    <Table
                                                        columns={columnsGP({
                                                            showFile: downFile,
                                                            handleShowDetail: handleShowGPDetail
                                                        })}
                                                        selectedRowId={selectedItemGP}
                                                        dataSource={dataCTbyGiayPhep}
                                                        onChange={(pagination, filteredInfo, sortedInfo) => handleTableParamsChange(pagination, filteredInfo, sortedInfo, values, "GP")}
                                                        pagination={{
                                                            total: pagination.total,
                                                            pageSize: 10,
                                                            current: pagination.currentPage,
                                                        }}
                                                        scroll={{ y: 540 }}
                                                    />
                                                </TabPane>
                                                <TabPane tab="DTM" key="2">
                                                    <Table
                                                        columns={columnsDTM({
                                                            showFile: showFileMT,
                                                            handleShowDetail: handleShowDTMDetail
                                                        })}
                                                        selectedRowId={selected_DTM}
                                                        dataSource={dataDTM}
                                                        onChange={(pagination, filteredInfo, sortedInfo) => handleTableParamsChange(pagination, filteredInfo, sortedInfo, values, "DTM")}
                                                        pagination={{
                                                            total: pagination.total,
                                                            pageSize: 10,
                                                            current: pagination.currentPage,
                                                        }}
                                                        scroll={{ y: 540 }}
                                                    />
                                                </TabPane>
                                                <TabPane tab="BVMT" key="3">
                                                    <Table
                                                        columns={columnsBVMT({
                                                            showFile: showFileMT,
                                                            handleShowDetail: handleShowBVMTDetail
                                                        })}
                                                        selectedRowId={selected_BVMT}
                                                        dataSource={dataBVMT}
                                                        onChange={(pagination, filteredInfo, sortedInfo) => handleTableParamsChange(pagination, filteredInfo, sortedInfo, values, "BVMT")}
                                                        pagination={{
                                                            total: pagination.total,
                                                            pageSize: 10,
                                                            current: pagination.currentPage,
                                                        }}
                                                        scroll={{ y: 540 }}
                                                    />
                                                </TabPane>
                                            </Tabs>
                                        )}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col style={{ width: "450px", marginLeft: "25px", display: displayInfo }}>
                                        <Tabs type="card">
                                            {dataThuocHuyen.qt_bvmt_tramquantrac_intersect && dataThuocHuyen.qt_bvmt_tramquantrac_intersect.length > 0 && (
                                                <TabPane tab="QT_BVMT" key="2">
                                                    <Table
                                                        columns={columns({})}
                                                        onRowClick={(record) => {
                                                            setselectedItemInfo_tramQT(true)
                                                            setdata_modal_mau({
                                                                idGiayPhep: record && record.thongtinchung_id,
                                                                idTramQT: record && record.idtramquantrac,
                                                                loai: 2,
                                                                kyHieu: undefined
                                                            })
                                                            dulieu_moitruong(record, "BVMT")
                                                        }}
                                                        dataSource={dataThuocHuyen.qt_bvmt_tramquantrac_intersect.map((item, index) => ({ ...item, stt: index + 1 }))}
                                                        pagination={false}
                                                        scroll={{ y: 540 }}
                                                    />
                                                </TabPane>
                                            )}
                                            {dataThuocHuyen.qt_dtm_tramquantrac_intersect && dataThuocHuyen.qt_dtm_tramquantrac_intersect.length > 0 && (
                                                <TabPane tab="QT_DTM" key="3">
                                                    <Table
                                                        columns={columns({})}
                                                        onRowClick={(record) => {
                                                            setselectedItemInfo_tramQT(true)
                                                            setdata_modal_mau({
                                                                idGiayPhep: record && record.thongtinchung_id,
                                                                idTramQT: record && record.idtramquantrac,
                                                                loai: 1,
                                                                kyHieu: undefined
                                                            })
                                                            dulieu_moitruong(record, "DTM")
                                                        }}
                                                        dataSource={dataThuocHuyen.qt_dtm_tramquantrac_intersect.map((item, index) => ({ ...item, stt: index + 1 }))}
                                                        pagination={false}
                                                        scroll={{ y: 540 }}
                                                    />
                                                </TabPane>
                                            )}
                                            {dataThuocHuyen.qt_duan_hangmuc_intersect && dataThuocHuyen.qt_duan_hangmuc_intersect.length > 0 && (
                                                <TabPane tab="QT_DA_HM" key="4">
                                                    <Table
                                                        columns={columsHangMuc({})}
                                                        onRowClick={(record) => {dulieu_moitruong(record, "DA_HM")}}
                                                        dataSource={dataThuocHuyen.qt_duan_hangmuc_intersect.map((item, index) => ({ ...item, stt: index + 1 }))}
                                                        pagination={false}
                                                        scroll={{ y: 540 }}
                                                    />
                                                </TabPane>
                                            )}
                                            {dataThuocHuyen.qt_duan_intersect && dataThuocHuyen.qt_duan_intersect.length > 0 && (
                                                <TabPane tab="QT_DUAN" key="5">
                                                    <Table
                                                        columns={columnsDuAn({})}
                                                        onRowClick={(record) => {dulieu_moitruong(record, "DUAN") }}
                                                        dataSource={dataThuocHuyen.qt_duan_intersect.map((item, index) => ({ ...item, stt: index + 1, }))}
                                                        pagination={false}
                                                        scroll={{ y: 540 }}
                                                    />
                                                </TabPane>
                                            )}
                                            {dataThuocHuyen.qt_ntts_tramquantrac_intersect && dataThuocHuyen.qt_ntts_tramquantrac_intersect.length > 0 && (
                                                <TabPane tab="QT_NTTS" key="6">
                                                    <Table
                                                        columns={columns({})}
                                                        onRowClick={(record) => {dulieu_moitruong(record, "NTTS") }}
                                                        dataSource={dataThuocHuyen.qt_ntts_tramquantrac_intersect.map((item, index) => ({ ...item, stt: index + 1, }))}
                                                        pagination={false}
                                                        scroll={{ y: 540 }}
                                                    />
                                                </TabPane>
                                            )}
                                            {dataThuocHuyen.qt_qdxp_tramquantrac_intersect && dataThuocHuyen.qt_qdxp_tramquantrac_intersect.length > 0 && (
                                                <TabPane tab="QT_QDXP" key="7">
                                                    <Table
                                                        columns={columns({})}
                                                        onRowClick={(record) => {dulieu_moitruong(record, "QDXP") }}
                                                        dataSource={dataThuocHuyen.qt_qdxp_tramquantrac_intersect.map((item, index) => ({ ...item, stt: index + 1 }))}
                                                        pagination={false}
                                                        scroll={{ y: 540 }}
                                                    />
                                                </TabPane>
                                            )}
                                            {dataThuocHuyen.qt_quantrac_intersect && dataThuocHuyen.qt_quantrac_intersect.length > 0 && (
                                                <TabPane tab="QT_HTMT" key="8">
                                                    <Table
                                                        columns={columns({})}
                                                        onRowClick={(record) => {
                                                            setselectedItemInfo_tramQT_HTMT(true)
                                                            setdata_modal_mau({
                                                                idGiayPhep: undefined,
                                                                idTramQT: record && record.idtramquantrac,
                                                                loai: 3,
                                                                kyHieu: record && record.kyhieu
                                                            })
                                                            dulieu_moitruong(record, "HTMT")
                                                        }}
                                                        dataSource={dataThuocHuyen.qt_quantrac_intersect.map((item, index) => ({ ...item, stt: index + 1, }))}
                                                        pagination={false}
                                                        scroll={{ y: 540 }}
                                                    />
                                                </TabPane>
                                            )}

                                        </Tabs>
                                    </Col>
                                </Row>
                            </Col>
                        )}
                    </FilterWrapper>
                </Col>
            </Row>
            {setModal &&
                <DownloadFileModal
                    isOpen={setModal}
                    handleCancel={() => handleCancel()}
                    selectdFile={selectdFile}
                />}
            {selectedItemGP &&
                <Modal
                    title={typo.cscore_thong_tin_chi_tiet}
                    centered
                    closable={true}
                    visible={selectedItemGP}
                    width="80%"
                    footer={null}
                    onCancel={() => handleCancel()}
                    maskClosable={false}
                >
                    <GiayPhepDetail idGiayPhep={selectedItemGP} handleMap={(item) => { }} />
                </Modal>
            }
            {selected_DTM &&
                <Modal
                    title={typo.cscore_thong_tin_chi_tiet}
                    centered
                    closable={true}
                    visible={selected_DTM}
                    width="80%"
                    footer={null}
                    onCancel={() => handleCancel()}
                    maskClosable={false}
                >
                    <DTMDetail idGiayPhep={selected_DTM} isMap={true} handleMap={(item) => { }} showmap="showmap" />
                </Modal>
            }
            {selected_BVMT &&
                <Modal
                    title={typo.cscore_thong_tin_chi_tiet}
                    centered
                    closable={true}
                    visible={selected_BVMT}
                    width="80%"
                    footer={null}
                    onCancel={() => handleCancel()}
                    maskClosable={false}
                >
                    <BVMTDetail idGiayPhep={selected_BVMT} isMap={true} handleMap={(item) => { }} showmap="showmap" />
                </Modal>
            }
            {selectedItemInfo_tramQT &&
                <Modal
                    title={typo.cscore_thong_tin_chi_tiet}
                    centered
                    closable={true}
                    visible={selectedItemInfo_tramQT}
                    width="80%"
                    footer={null}
                    onCancel={() => handleCancel()}
                    maskClosable={false}
                >
                    <InfoTramQTModal
                        user={user}
                        data_modal_mau={data_modal_mau}
                    />
                </Modal>
            }
            {selectedItemInfo_tramQT_HTMT &&
                <Modal
                    title={typo.cscore_thong_tin_chi_tiet}
                    centered
                    closable={true}
                    visible={selectedItemInfo_tramQT_HTMT}
                    width="80%"
                    footer={null}
                    onCancel={() => handleCancel()}
                    maskClosable={false}
                >
                    <InfoTramQT_HTMT idTramQuanTrac={data_modal_mau.idTramQT} editable={true} />
                </Modal>
            }

        </ControllerCheckbox>
    );
}
export default FuncMap